"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigurations = exports.deleteProcureVendorContact = exports.updateProcureVendorContact = exports.createProcureVendorContact = exports.getProcureVendorContactById = exports.getProcureVendorContactsByProcureVendorId = exports.deleteProcureVendor = exports.updateProcureVendor = exports.createProcureVendor = exports.getProcureVendorById = exports.getProcureVendorsWithFilters = exports.createUserFeedback = exports.getWorkOrderBidById = exports.getWorkOrderBidsByWorkOrderId = exports.getWorkOrderCommentsByWorkOrderId = exports.getWorkOrderCommentById = exports.deleteWorkOrderComment = exports.updateWorkOrderComment = exports.createWorkOrderComment = exports.getWorkOrdersWithFilters = exports.getWorkOrderById = exports.deleteWorkOrder = exports.updateWorkOrder = exports.createWorkOrder = exports.getIssues = exports.getIssueTypes = exports.getWorkOrderPriorities = exports.getWorkOrderStatuses = exports.getProperties = exports.getPropertyById = exports.deleteProperty = exports.updateProperty = exports.createProperty = exports.getOrganizationAccount = exports.deleteOrganizationAccount = exports.updateOrganizationAccount = exports.createOrganizationAccount = exports.getNotifications = exports.getUserNotificationSettings = exports.updateUserNotificationSetting = exports.getUserInvitations = exports.createUserInvitations = exports.getUserRoles = exports.getUsersWithFilters = exports.getUserById = exports.deleteUser = exports.removeUser = exports.updateUserRole = exports.updateUser = exports.me = void 0;
exports.deleteAsset = exports.updateAsset = exports.createAsset = exports.getAssetTypes = exports.getAssetsWithFilters = exports.getAssetById = exports.updateUserConfiguration = void 0;
const client_1 = require("@apollo/client");
const fragments_graphql_1 = require("../fragments.graphql");
exports.me = (0, client_1.gql) `
  query me {
    me {
      id
      userId
      firstName
      lastName
      fullName
      usersInvitedCount
      workOrdersCreatedCount
      emailContactMethod {
        id
        type
        value
        verified
      }
      phoneContactMethod {
        id
        type
        value
        verified
        userInvitations {
          id
          firstName
          lastName
          organizationAccountId
          organizationAccount {
            id
            name
          }
          invitedByUser {
            id
            firstName
            lastName
            fullName
          }
          userRole {
            id
            name
            description
          }
          propertyIds
          sentAt
          acceptedAt
          canceledAt
          expiresAt
          inviteStatus
          createdAt
        }
      }
      organizationAccount {
        id
        name
      }
      properties {
        id
        organizationAccountId
        name
        fullAddress
        address1
        address2
        city
        state
        zipcode
        latitude
        longitude
        createdByUserId
        updatedByUserId
      }
      userRole {
        id
        name
        description
        userPermissions {
          id
          name
          displayName
          description
        }
      }
      status
      profilePictureAttachmentId
      profilePictureAttachment {
        id
        path
        fileType
        status
        url
        urlExpiresAt
      }
    }
  }
`;
exports.updateUser = (0, client_1.gql) `
  mutation updateUser($input: UserInput!) {
    updateUser(input: $input) {
      id
    }
  }
`;
exports.updateUserRole = (0, client_1.gql) `
  mutation updateUserRole($id: ID!, $input: UserRoleInput!) {
    updateUserRole(id: $id, input: $input) {
      id
    }
  }
`;
exports.removeUser = (0, client_1.gql) `
  mutation removeUser($id: ID!) {
    removeUser(id: $id) {
      id
    }
  }
`;
exports.deleteUser = (0, client_1.gql) `
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`;
exports.getUserById = (0, client_1.gql) `
  query getUserById($id: ID!) {
    getUserById(id: $id) {
      id
      firstName
      lastName
      fullName
      emailContactMethod {
        id
        type
        value
        verified
      }
      phoneContactMethod {
        id
        type
        value
        verified
      }
      organizationAccount {
        id
        name
      }
      properties {
        id
        organizationAccountId
        name
        fullAddress
        address1
        address2
        city
        state
        zipcode
        latitude
        longitude
        createdByUserId
        updatedByUserId
      }
      userRole {
        id
        name
        description
        userPermissions {
          id
          name
          displayName
          description
        }
      }
      status
      profilePictureAttachmentId
      profilePictureAttachment {
        id
        path
        fileType
        status
        url
        urlExpiresAt
      }
    }
  }
`;
exports.getUsersWithFilters = (0, client_1.gql) `
  query getUsersWithFilters(
    $propertyIds: [ID]
    $userRoleIds: [ID]
    $userIds: [ID]
    $getSendbirdUsers: Boolean
  ) {
    getUsersWithFilters(
      propertyIds: $propertyIds
      userRoleIds: $userRoleIds
      userIds: $userIds
      getSendbirdUsers: $getSendbirdUsers
    ) {
      id
      firstName
      lastName
      fullName
      emailContactMethod {
        id
        type
        value
        verified
      }
      phoneContactMethod {
        id
        type
        value
        verified
      }
      organizationAccount {
        id
        name
      }
      properties {
        id
        organizationAccountId
        name
        fullAddress
        address1
        address2
        city
        state
        zipcode
        latitude
        longitude
        createdByUserId
        updatedByUserId
      }
      userRole {
        id
        name
        description
        userPermissions {
          id
          name
          displayName
          description
        }
      }
      status
      profilePictureAttachmentId
      profilePictureAttachment {
        id
        path
        fileType
        status
        url
        urlExpiresAt
      }
      sendbirdUser {
        user_id
        nickname
        profile_url
        is_online
        is_active
        has_ever_logged_in
        last_seen_at
      }
      createdAt
    }
  }
`;
exports.getUserRoles = (0, client_1.gql) `
  query getUserRoles {
    getUserRoles {
      id
      name
      description
      userPermissions {
        id
        name
        displayName
        description
      }
    }
  }
`;
exports.createUserInvitations = (0, client_1.gql) `
  mutation createUserInvitations($input: [UserInvitationInput]) {
    createUserInvitations(input: $input) {
      id
      firstName
      lastName
      organizationAccountId
      invitedByUserId
      userRoleId
      propertyIds
      contactMethodId
      sentAt
      acceptedAt
      canceledAt
      expiresAt
    }
  }
`;
exports.getUserInvitations = (0, client_1.gql) `
  query getUserInvitations($isPendingOnly: Boolean) {
    getUserInvitations(isPendingOnly: $isPendingOnly) {
      id
      firstName
      lastName
      organizationAccountId
      invitedByUser {
        id
        firstName
        lastName
        fullName
      }
      userRole {
        id
        name
        description
      }
      propertyIds
      contactMethod {
        id
        type
        value
        verified
      }
      sentAt
      acceptedAt
      canceledAt
      expiresAt
      inviteStatus
    }
  }
`;
exports.updateUserNotificationSetting = (0, client_1.gql) `
  mutation updateUserNotificationSetting(
    $notificationTypeId: ID!
    $input: UserNotificationSettingInput!
  ) {
    updateUserNotificationSetting(notificationTypeId: $notificationTypeId, input: $input) {
      userId
      notificationTypeId
      pushEnabled
      textEnabled
      emailEnabled
    }
  }
`;
exports.getUserNotificationSettings = (0, client_1.gql) `
  query getUserNotificationSettings {
    getUserNotificationSettings {
      userId
      notificationTypeId
      notificationType {
        id
        notificationCategory {
          id
          name
          description
          priority
        }
        name
        description
        priority
        pushEnabledDefault
        textEnabledDefault
        emailEnabledDefault
      }
      pushEnabled
      textEnabled
      emailEnabled
    }
  }
`;
exports.getNotifications = (0, client_1.gql) `
  query getNotifications($offset: Int, $limit: Int) {
    getNotifications(offset: $offset, limit: $limit) {
      id
      notificationTypeId
      notificationType {
        id
        notificationCategory {
          id
          name
          description
          priority
        }
        name
        description
        priority
        pushEnabledDefault
        textEnabledDefault
        emailEnabledDefault
      }
      userId
      triggeredByUserId
      viewedAt
      content
      createdAt
    }
  }
`;
exports.createOrganizationAccount = (0, client_1.gql) `
  mutation createOrganizationAccount($input: OrganizationAccountInput!) {
    createOrganizationAccount(input: $input) {
      id
      name
    }
  }
`;
exports.updateOrganizationAccount = (0, client_1.gql) `
  mutation updateOrganizationAccount($id: ID!, $input: OrganizationAccountInput!) {
    updateOrganizationAccount(id: $id, input: $input) {
      id
      name
    }
  }
`;
exports.deleteOrganizationAccount = (0, client_1.gql) `
  mutation deleteOrganizationAccount($id: ID!) {
    deleteOrganizationAccount(id: $id) {
      id
    }
  }
`;
exports.getOrganizationAccount = (0, client_1.gql) `
  query getOrganizationAccount {
    getOrganizationAccount {
      id
      name
    }
  }
`;
exports.createProperty = (0, client_1.gql) `
  mutation createProperty($input: PropertyInput!) {
    createProperty(input: $input) {
      id
      organizationAccountId
      name
      address1
      address2
      city
      state
      zipcode
      latitude
      longitude
      createdByUserId
      updatedByUserId
    }
  }
`;
exports.updateProperty = (0, client_1.gql) `
  mutation updateProperty($id: ID!, $input: PropertyInput!) {
    updateProperty(id: $id, input: $input) {
      id
      organizationAccountId
      name
      address1
      address2
      city
      state
      zipcode
      latitude
      longitude
      createdByUserId
      updatedByUserId
    }
  }
`;
exports.deleteProperty = (0, client_1.gql) `
  mutation deleteProperty($id: ID!) {
    deleteProperty(id: $id) {
      id
    }
  }
`;
exports.getPropertyById = (0, client_1.gql) `
  query getPropertyById($id: ID!) {
    getPropertyById(id: $id) {
      id
      organizationAccountId
      name
      fullAddress
      address1
      address2
      city
      state
      zipcode
      latitude
      longitude
      createdByUserId
      updatedByUserId
      tenantWorkOrderForm {
        id
        hash
        enabled
      }
      assets {
        id
        make
        model
      }
    }
  }
`;
exports.getProperties = (0, client_1.gql) `
  query getProperties {
    getProperties {
      id
      organizationAccountId
      name
      fullAddress
      address1
      address2
      city
      state
      zipcode
      latitude
      longitude
      createdByUserId
      updatedByUserId
      tenantWorkOrderForm {
        id
        hash
        enabled
      }
    }
  }
`;
exports.getWorkOrderStatuses = (0, client_1.gql) `
  query getWorkOrderStatuses {
    getWorkOrderStatuses {
      id
      name
      description
    }
  }
`;
exports.getWorkOrderPriorities = (0, client_1.gql) `
  query getWorkOrderPriorities {
    getWorkOrderPriorities {
      id
      name
      description
    }
  }
`;
exports.getIssueTypes = (0, client_1.gql) `
  query getIssueTypes {
    getIssueTypes {
      id
      name
      description
    }
  }
`;
exports.getIssues = (0, client_1.gql) `
  query getIssues {
    getIssues {
      id
      issueType {
        id
        name
        description
      }
      name
      description
      priceRangeFloor
      priceRangeCeiling
    }
  }
`;
exports.createWorkOrder = (0, client_1.gql) `
  mutation createWorkOrder($input: WorkOrderCreateInput!) {
    createWorkOrder(input: $input) {
      id
      propertyId
      title
      description
      dueDate
      propertyLocation
      conciergeEnabled
      conciergeLastEnabledAt
      conciergeLastDisabledAt
      completedAt
      creationStatus
    }
  }
`;
exports.updateWorkOrder = (0, client_1.gql) `
  mutation updateWorkOrder($id: ID!, $input: WorkOrderUpdateInput!) {
    updateWorkOrder(id: $id, input: $input) {
      id
      propertyId
      title
      description
      dueDate
      propertyLocation
      conciergeEnabled
      conciergeLastEnabledAt
      conciergeLastDisabledAt
      completedAt
      creationStatus
      bidsRequested
      maxBudget
    }
  }
`;
exports.deleteWorkOrder = (0, client_1.gql) `
  mutation deleteWorkOrder($id: ID!, $cascadeToWorkOrderTemplate: Boolean) {
    deleteWorkOrder(id: $id, cascadeToWorkOrderTemplate: $cascadeToWorkOrderTemplate) {
      id
    }
  }
`;
exports.getWorkOrderById = (0, client_1.gql) `
  ${fragments_graphql_1.PROCURE_VENDOR_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_TEMPLATE_FIELDS}
  query getWorkOrderById($id: ID!) {
    getWorkOrderById(id: $id) {
      id
      propertyId
      property {
        id
        organizationAccountId
        name
        fullAddress
        address1
        address2
        city
        state
        zipcode
        latitude
        longitude
        createdByUserId
        updatedByUserId
      }
      workOrderStatus {
        id
        name
        description
      }
      assignedUser {
        id
        firstName
        lastName
        fullName
        status
        profilePictureAttachmentId
        profilePictureAttachment {
          id
          path
          fileType
          status
          url
          urlExpiresAt
        }
      }
      workOrderPriority {
        id
        name
        description
      }
      issueType {
        id
        name
        description
      }
      title
      description
      dueDate
      propertyLocation
      conciergeEnabled
      conciergeLastEnabledAt
      conciergeLastDisabledAt
      completedAt
      creationStatus
      createdAt
      bidsRequested
      maxBudget
      createdByUser {
        id
        firstName
        lastName
        fullName
        procureUser {
          id
          status
          profilePictureAttachmentId
          profilePictureAttachment {
            id
            path
            fileType
            status
            url
            urlExpiresAt
          }
        }
      }
      attachments {
        id
        path
        fileType
        status
        url
        urlExpiresAt
        createdAt
        createdByUser {
          id
          fullName
        }
      }
      workOrderBidAttachments {
        id
        path
        fileType
        status
        url
        urlExpiresAt
        createdAt
        createdByUser {
          id
          fullName
        }
      }
      workOrderWatcherUsers {
        id
        firstName
        lastName
        fullName
        status
        profilePictureAttachmentId
        profilePictureAttachment {
          id
          path
          fileType
          status
          url
          urlExpiresAt
        }
      }
      procureVendor {
        ...ProcureVendorFields
      }
      workOrderTemplate {
        ...WorkOrderTemplateFields
      }
      tenantWorkOrderSubmission {
        id
        tenantFirstName
        tenantLastName
      }
      assets {
        id
        make
        model
      }
    }
  }
`;
exports.getWorkOrdersWithFilters = (0, client_1.gql) `
  ${fragments_graphql_1.PROCURE_VENDOR_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_TEMPLATE_FIELDS}
  query getWorkOrdersWithFilters(
    $propertyIds: [ID]
    $workOrderStatusIds: [ID]
    $assigneeUserIds: [ID]
    $workOrderPriorityIds: [ID]
    $issueTypeIds: [ID]
    $createdByIds: [ID]
    $procureVendorIds: [ID]
    $createdAtStart: Date
    $createdAtEnd: Date
    $dueDateStart: Date
    $dueDateEnd: Date
    $searchText: String
    $sortBy: String
    $creationStatus: String
    $isRecurring: Boolean
    $isTenantCreated: Boolean
    $isConciergeEnabled: Boolean
  ) {
    getWorkOrdersWithFilters(
      propertyIds: $propertyIds
      workOrderStatusIds: $workOrderStatusIds
      assigneeUserIds: $assigneeUserIds
      workOrderPriorityIds: $workOrderPriorityIds
      issueTypeIds: $issueTypeIds
      createdByIds: $createdByIds
      procureVendorIds: $procureVendorIds
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      dueDateStart: $dueDateStart
      dueDateEnd: $dueDateEnd
      searchText: $searchText
      sortBy: $sortBy
      creationStatus: $creationStatus
      isRecurring: $isRecurring
      isTenantCreated: $isTenantCreated
      isConciergeEnabled: $isConciergeEnabled
    ) {
      id
      propertyId
      property {
        id
        organizationAccountId
        name
        fullAddress
        address1
        address2
        city
        state
        zipcode
        latitude
        longitude
        createdByUserId
        updatedByUserId
      }
      workOrderStatus {
        id
        name
        description
      }
      assignedUser {
        id
        firstName
        lastName
        fullName
        status
        profilePictureAttachmentId
        profilePictureAttachment {
          id
          path
          fileType
          status
          url
          urlExpiresAt
        }
      }
      workOrderPriority {
        id
        name
        description
      }
      issueType {
        id
        name
        description
      }
      title
      description
      dueDate
      propertyLocation
      conciergeEnabled
      conciergeLastEnabledAt
      conciergeLastDisabledAt
      completedAt
      creationStatus
      bidsRequested
      maxBudget
      createdAt
      createdByUser {
        id
        firstName
        lastName
        fullName
        procureUser {
          id
          status
          profilePictureAttachmentId
          profilePictureAttachment {
            id
            path
            fileType
            status
            url
            urlExpiresAt
          }
        }
      }
      attachments {
        id
        path
        fileType
        status
        url
        urlExpiresAt
      }
      workOrderBidAttachments {
        id
        path
        fileType
        status
        url
        urlExpiresAt
        createdAt
        createdByUser {
          id
          fullName
        }
      }
      workOrderWatcherUsers {
        id
        firstName
        lastName
        fullName
        status
        profilePictureAttachmentId
        profilePictureAttachment {
          id
          path
          fileType
          status
          url
          urlExpiresAt
        }
      }
      procureVendor {
        ...ProcureVendorFields
      }
      workOrderTemplate {
        ...WorkOrderTemplateFields
      }
      tenantWorkOrderSubmission {
        id
        tenantFirstName
        tenantLastName
      }
      assets {
        id
        make
        model
      }
    }
  }
`;
exports.createWorkOrderComment = (0, client_1.gql) `
  mutation createWorkOrderComment($input: WorkOrderCommentCreateInput!) {
    createWorkOrderComment(input: $input) {
      id
      workOrderId
      content
    }
  }
`;
exports.updateWorkOrderComment = (0, client_1.gql) `
  mutation updateWorkOrderComment($id: ID!, $input: WorkOrderCommentUpdateInput!) {
    updateWorkOrderComment(id: $id, input: $input) {
      id
      workOrderId
      content
    }
  }
`;
exports.deleteWorkOrderComment = (0, client_1.gql) `
  mutation deleteWorkOrderComment($id: ID!) {
    deleteWorkOrderComment(id: $id) {
      id
    }
  }
`;
exports.getWorkOrderCommentById = (0, client_1.gql) `
  query getWorkOrderCommentById($id: ID!) {
    getWorkOrderCommentById(id: $id) {
      id
      workOrderId
      content
      createdAt
      attachments {
        id
        path
        fileType
        status
        url
        urlExpiresAt
      }
      user {
        id
        firstName
        lastName
        fullName
        procureUser {
          id
          userRole {
            id
            name
          }
          profilePictureAttachmentId
          profilePictureAttachment {
            id
            path
            fileType
            status
            url
            urlExpiresAt
          }
        }
      }
    }
  }
`;
exports.getWorkOrderCommentsByWorkOrderId = (0, client_1.gql) `
  query getWorkOrderCommentsByWorkOrderId($workOrderId: ID!) {
    getWorkOrderCommentsByWorkOrderId(workOrderId: $workOrderId) {
      id
      workOrderId
      content
      createdAt
      attachments {
        id
        path
        fileType
        status
        url
        urlExpiresAt
      }
      user {
        id
        firstName
        lastName
        fullName
        procureUser {
          id
          userRole {
            id
            name
          }
          profilePictureAttachmentId
          profilePictureAttachment {
            id
            path
            fileType
            status
            url
            urlExpiresAt
          }
        }
      }
    }
  }
`;
exports.getWorkOrderBidsByWorkOrderId = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_BID_FIELDS}
  query getWorkOrderBidsByWorkOrderId($workOrderId: ID!) {
    getWorkOrderBidsByWorkOrderId(workOrderId: $workOrderId) {
      ...WorkOrderBidFields
      attachments {
        ...AttachmentFields
      }
      conciergeVendor {
        ...ConciergeVendorFields
      }
    }
  }
`;
exports.getWorkOrderBidById = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_BID_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_FIELDS}
  query getWorkOrderBidById($id: ID!) {
    getWorkOrderBidById(id: $id) {
      ...WorkOrderBidFields
      workOrderBidRequest {
        id
        workOrder {
          ...WorkOrderFields
        }
      }
      attachments {
        ...AttachmentFields
      }
      conciergeVendor {
        ...ConciergeVendorFields
      }
    }
  }
`;
exports.createUserFeedback = (0, client_1.gql) `
  mutation createUserFeedback($input: UserFeedbackInput!) {
    createUserFeedback(input: $input) {
      id
      rating
      content
      createdByUserId
    }
  }
`;
exports.getProcureVendorsWithFilters = (0, client_1.gql) `
  ${fragments_graphql_1.PROCURE_VENDOR_FIELDS}
  query getProcureVendorsWithFilters($issueTypeIds: [ID], $propertyIds: [ID]) {
    getProcureVendorsWithFilters(issueTypeIds: $issueTypeIds, propertyIds: $propertyIds) {
      ...ProcureVendorFields
    }
  }
`;
exports.getProcureVendorById = (0, client_1.gql) `
  ${fragments_graphql_1.PROCURE_VENDOR_FIELDS}
  query getProcureVendorById($id: ID!) {
    getProcureVendorById(id: $id) {
      ...ProcureVendorFields
    }
  }
`;
exports.createProcureVendor = (0, client_1.gql) `
  mutation createProcureVendor($input: ProcureVendorCreateInput!) {
    createProcureVendor(input: $input) {
      id
    }
  }
`;
exports.updateProcureVendor = (0, client_1.gql) `
  mutation updateProcureVendor($id: ID!, $input: ProcureVendorUpdateInput!) {
    updateProcureVendor(id: $id, input: $input) {
      id
    }
  }
`;
exports.deleteProcureVendor = (0, client_1.gql) `
  mutation deleteProcureVendor($id: ID!) {
    deleteProcureVendor(id: $id) {
      id
    }
  }
`;
exports.getProcureVendorContactsByProcureVendorId = (0, client_1.gql) `
  ${fragments_graphql_1.PROCURE_VENDOR_CONTACT_FIELDS}
  query getProcureVendorContactsByProcureVendorId($procureVendorId: ID!) {
    getProcureVendorContactsByProcureVendorId(procureVendorId: $procureVendorId) {
      ...ProcureVendorContactFields
    }
  }
`;
exports.getProcureVendorContactById = (0, client_1.gql) `
  ${fragments_graphql_1.PROCURE_VENDOR_CONTACT_FIELDS}
  query getProcureVendorContactById($id: ID!) {
    getProcureVendorContactById(id: $id) {
      ...ProcureVendorContactFields
    }
  }
`;
exports.createProcureVendorContact = (0, client_1.gql) `
  mutation createProcureVendorContact($input: ProcureVendorContactCreateInput!) {
    createProcureVendorContact(input: $input) {
      id
    }
  }
`;
exports.updateProcureVendorContact = (0, client_1.gql) `
  mutation updateProcureVendorContact($id: ID!, $input: ProcureVendorContactUpdateInput!) {
    updateProcureVendorContact(id: $id, input: $input) {
      id
    }
  }
`;
exports.deleteProcureVendorContact = (0, client_1.gql) `
  mutation deleteProcureVendorContact($id: ID!) {
    deleteProcureVendorContact(id: $id) {
      id
    }
  }
`;
exports.getConfigurations = (0, client_1.gql) `
  query getConfigurations {
    getConfigurations {
      id
      name
      value
      valueType
      lastAccessedAt
      createdAt
      updatedAt
      updatedByUserId
    }
  }
`;
exports.updateUserConfiguration = (0, client_1.gql) `
  mutation updateUserConfiguration($input: UserConfigurationUpdateInput!) {
    updateUserConfiguration(input: $input) {
      id
    }
  }
`;
exports.getAssetById = (0, client_1.gql) `
  query getAssetById($id: ID!) {
    getAssetById(id: $id) {
      id
      make
      model
    }
  }
`;
exports.getAssetsWithFilters = (0, client_1.gql) `
  query getAssetsWithFilters($propertyIds: [ID], $issueTypeIds: [ID]) {
    getAssetsWithFilters(propertyIds: $propertyIds, issueTypeIds: $issueTypeIds) {
      id
      make
      model
    }
  }
`;
exports.getAssetTypes = (0, client_1.gql) `
  query getAssetTypes {
    getAssetTypes {
      id
      name
      issueType {
        id
        name
      }
    }
  }
`;
exports.createAsset = (0, client_1.gql) `
  mutation createAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      id
    }
  }
`;
exports.updateAsset = (0, client_1.gql) `
  mutation updateAsset($id: ID!, $input: UpdateAssetInput!) {
    updateAsset(id: $id, input: $input) {
      id
    }
  }
`;
exports.deleteAsset = (0, client_1.gql) `
  mutation deleteAsset($id: ID!) {
    deleteAsset(id: $id) {
      id
    }
  }
`;
//# sourceMappingURL=procure-queries.graphql.js.map